import React, { useState, useRef, useEffect } from 'react';
import {
  Card, CardBody, CardTitle, Nav, NavItem, NavLink, TabContent, TabPane,
  Row, Col, Label, Input, Form, Button, Badge, InputGroup
} from 'reactstrap';
import classnames from 'classnames';
import CustomEditor from '../../components/CustomEditor';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import api, { FILE_BASE_URL } from '../../utils/api';
import useDuplicateCheck from '../../helpers/useDuplicateCheck';
import DuplicateWarning, { DuplicateSaveConfirm } from '../../components/DuplicateWarning';
import { Editor } from '@tinymce/tinymce-react';

const CreateInstitution = (props) => {
  const { mode = 'create', institutionData = null } = props;
  const imageInputRef = useRef(null);
  const attachmentInputRef = useRef(null);
  const logoInputRef = useRef(null); // 🆕 لللوجو
  const representativeImageRef = useRef(null); // 🆕 لصورة المسؤول
  const videoInputRef = useRef(null); // 🆕 مرجع رفع الفيديو
  
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [logo, setLogo] = useState(null); // 🆕 حالة اللوجو
  const [representativeImage, setRepresentativeImage] = useState(null); // 🆕 حالة صورة المسؤول
  const [journalistsList, setJournalistsList] = useState([]); // 🆕 قائمة الصحفيين
  const [activistsList, setActivistsList] = useState([]); // 🆕 قائمة الناشطين
  const [institutionsList, setInstitutionsList] = useState([]); // 🔗 لربط مؤسسة بمؤسسة أخرى
  const [selectedInstitutionPeers, setSelectedInstitutionPeers] = useState([]); // 🔗 مؤسسات أخرى مرتبطة

  // 🆕 حالات البحث المتقدم
  const [journalistSearchTerm, setJournalistSearchTerm] = useState('');
  const [activistSearchTerm, setActivistSearchTerm] = useState('');
  const [institutionPeerSearchTerm, setInstitutionPeerSearchTerm] = useState('');
  const [filteredJournalists, setFilteredJournalists] = useState([]);
  const [filteredActivists, setFilteredActivists] = useState([]);
  const [filteredInstitutionPeers, setFilteredInstitutionPeers] = useState([]);

  // فحص الأسماء المكررة
  const { duplicateWarning, checkingDuplicate, duplicateError, handleNameBlur, handleNameChange, dismissWarning, checkBeforeSave } = useDuplicateCheck('institution', institutionData?.id);
  const [showDuplicateConfirm, setShowDuplicateConfirm] = useState(false);
  
  const [formValues, setFormValues] = useState({
    title: '',
    description: '',
    logo: '', // 🆕 لوجو المؤسسة
    license_status: '',
    reference: '',
    orientation: '',
    responsible_type: 'new_person', // 🆕 نوع المسؤول
    responsible_journalist_id: '', // 🆕 ID الصحفي
    responsible_activist_id: '', // 🆕 ID الناشط
  new_person_type: '', // 🆕 نوع الشخص الجديد (ناشط/صحفي) - اترك فارغًا ليجبر المستخدم على الاختيار
    representative_name: '',
    representative_profile_image: '', // 🆕 صورة المسؤول
    representative_gender: '',
    representative_id_number: '',
    representative_birthdate: '',
    representative_political_orientation: [],
    country: 'فلسطين', // 🆕 الدولة مع القيمة الافتراضية
    country_province: '',
    city_or_area: '',
    address_details: '',
    map_address: '',
    whatsapp1_code: '+970',
    phone_fax: '',
    oreedo_number: '',
    whatsapp1_number: '',
    whatsapp1: '',
    mobile1: '',
    email: '',
    website: '',
    social_accounts: [],
    attachments: [],
    youtube_links: [],
    statements: [],
    video_files: [], // 🆕 ملفات فيديو مرفوعة
  });
  
  const [newYoutubeLink, setNewYoutubeLink] = useState('');
  const [newQuote, setNewQuote] = useState('');
  const [images, setImages] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]); // 🆕 ملفات الفيديو
  const [videoUploading, setVideoUploading] = useState({}); // 🆕 حالة رفع كل فيديو
  const [newSocialAccount, setNewSocialAccount] = useState('');
  // حالة لعرض مودال الأخطاء
  const [showErrorsModal, setShowErrorsModal] = useState(false);
  const [errorsList, setErrorsList] = useState([]); // [{ key, message, tabId, label }]
  const [errorsPerTab, setErrorsPerTab] = useState({});

  // خريطة الحقول إلى تبويب (قابلة لإعادة الاستخدام)
  const fieldTabMap = {
    title: '1', license_status: '1', reference: '1', orientation: '1', description: '1', logo: '1',
    responsible_journalist_id: '2', responsible_activist_id: '2', new_person_type: '2', representative_profile_image: '2', representative_name: '2', representative_gender: '2',
    country: '3', country_province: '3', city_or_area: '3', address_details: '3', map_address: '3',
    whatsapp1: '4', phone_fax: '4', mobile1: '4', email: '4', website: '4',
    images: '5', attachments: '5'
  };

  const humanLabels = {
    new_person_type: 'نوع الشخص',
    representative_profile_image: 'صورة المسؤول',
    representative_name: 'اسم الممثل',
  };

  // 🆕 دوال التعامل مع اللوجو
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  // 🆕 دوال التعامل مع صورة المسؤول
  const handleRepresentativeImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setRepresentativeImage(file);
    }
  };

  useEffect(() => {
    if (document.getElementById("map")) {
      const defaultPosition = { lat: 31.9522, lng: 35.2332 };
      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: defaultPosition,
        zoom: 13,
      });
      const marker = new window.google.maps.Marker({
        position: defaultPosition,
        map,
        draggable: true,
      });
      marker.addListener("dragend", () => {
        const position = marker.getPosition();
        setFormValues(prev => ({
          ...prev,
          map_address: `${position.lat()}, ${position.lng()}`,
        }));
      });
    }
  }, []);

  useEffect(() => {
    props.setBreadcrumbItems(mode === 'edit' ? 'تعديل مؤسسة' : 'إضافة مؤسسة', [
      { title: "الرئيسية", link: "/dashboard" },
      { title: "المؤسسات", link: "/dashboard/institutions" },
      { title: mode === 'edit' ? "تعديل مؤسسة" : "إضافة مؤسسة", link: "#" }
    ]);

    // 🆕 جلب قوائم الصحفيين والناشطين
    fetchJournalistsAndActivists();
    // 🔗 جلب قائمة كل المؤسسات لربط مؤسسة بمؤسسة أخرى
    fetchInstitutionsList();
  }, [mode, props.setBreadcrumbItems]);

  // 🔗 دالة جلب قائمة كل المؤسسات
  const fetchInstitutionsList = async () => {
    try {
      const res = await api.get('/institutions');
      const list = Array.isArray(res.data) ? res.data : res.data.data || [];
      setInstitutionsList(list);
    } catch (error) {
      console.error('خطأ في جلب قائمة المؤسسات:', error);
      setInstitutionsList([]);
    }
  };

  // عندما تتغير أخطاء النموذج، احسب أعداد الأخطاء لكل تبويب لعرض بادجات
  useEffect(() => {
    const perTab = {};
    // formErrors قد يكون من السيرفر أو محلي
    const keys = Object.keys(formErrors || {});
    keys.forEach(k => {
      const tab = fieldTabMap[k] || '1';
      perTab[tab] = (perTab[tab] || 0) + (Array.isArray(formErrors[k]) ? formErrors[k].length : 1);
    });
    setErrorsPerTab(perTab);
  }, [formErrors]);

  // 🆕 دالة جلب الصحفيين والناشطين - محدثة لاستخدام api
  const fetchJournalistsAndActivists = async () => {
    try {
      const [journalistsRes, activistsRes] = await Promise.all([
        api.get('/institutions/journalists'),
        api.get('/institutions/activists')
      ]);
      
      setJournalistsList(journalistsRes.data.data || []);
      setActivistsList(activistsRes.data.data || []);
    } catch (error) {
      console.error('خطأ في جلب قوائم الصحفيين والناشطين:', error);
      setJournalistsList([]);
      setActivistsList([]);
    }
  };

  useEffect(() => {
    if (mode === 'edit' && institutionData) {
      setFormValues({
        title: institutionData.title ?? '',
        description: institutionData.description ?? '',
        logo: institutionData.logo ?? '', // 🆕
        license_status: institutionData.license_status ?? '',
        reference: institutionData.reference ?? '',
        orientation: institutionData.orientation ?? '',
        responsible_type: institutionData.responsible_type ?? 'new_person', // 🆕
        responsible_journalist_id: institutionData.responsible_journalist_id ?? '', // 🆕
        responsible_activist_id: institutionData.responsible_activist_id ?? '', // 🆕
        representative_name: institutionData.representative_name ?? '',
  representative_profile_image: institutionData.representative_profile_image ?? '', // 🆕
  new_person_type: institutionData.new_person_type ?? '',
        representative_gender: institutionData.representative_gender ?? '',
        representative_id_number: institutionData.representative_id_number ?? '',
        representative_birthdate: institutionData.representative_birthdate ?? '',
        representative_political_orientation: institutionData.representative_political_orientation ? JSON.parse(institutionData.representative_political_orientation) : [],
        country: institutionData.country ?? 'فلسطين', // 🆕 إضافة حقل الدولة
        country_province: institutionData.country_province ?? '',
        city_or_area: institutionData.city_or_area ?? '',
        address_details: institutionData.address_details ?? '',
        map_address: institutionData.map_address ?? '',
        whatsapp1_code: institutionData.whatsapp1?.startsWith('+972') ? '+972' : '+970',
        whatsapp1_number: institutionData.whatsapp1 ? institutionData.whatsapp1.replace(/^\+970|\+972/, '') : '',
        mobile1: institutionData.mobile1 ?? '',
        phone_fax: institutionData.phone_fax ?? '',
        oreedo_number: institutionData.oreedo_number ?? '',
        email: institutionData.email ?? '',
        website: institutionData.website ?? '',
        social_accounts: institutionData.social_accounts ? JSON.parse(institutionData.social_accounts) : [],
        attachments: institutionData.attachments ? JSON.parse(institutionData.attachments) : [],
        youtube_links: institutionData.youtube_links ? JSON.parse(institutionData.youtube_links) : [],
        statements: institutionData.representative_statements ? JSON.parse(institutionData.representative_statements) : [],
        video_files: institutionData.video_files ? JSON.parse(institutionData.video_files) : [], // 🆕
      });
      
      // تحميل الصور الموجودة
      if (institutionData.images) {
        try {
          const parsedImages = JSON.parse(institutionData.images);
          setImages(parsedImages);
        } catch (e) {
          console.error("فشل في قراءة صور المؤسسة:", e);
          setImages([]);
        }
      } else {
        setImages([]);
      }

      // 🆕 تحميل ملفات الفيديو الموجودة
      if (institutionData.video_files) {
        try {
          const parsedVideoFiles = JSON.parse(institutionData.video_files);
          setVideoFiles(parsedVideoFiles);
        } catch (e) {
          console.error("فشل في قراءة ملفات الفيديو:", e);
          setVideoFiles([]);
        }
      } else {
        setVideoFiles([]);
      }
    }
  }, [mode, institutionData]);
  
  // 🆕 useEffect للبحث المتقدم في الصحفيين
  useEffect(() => {
    if (journalistSearchTerm.trim() === '') {
      setFilteredJournalists(journalistsList);
    } else {
      const filtered = journalistsList.filter(journalist =>
        journalist.full_name.toLowerCase().includes(journalistSearchTerm.toLowerCase())
      );
      setFilteredJournalists(filtered);
    }
  }, [journalistSearchTerm, journalistsList]);

  // 🆕 useEffect للبحث المتقدم في الناشطين
  useEffect(() => {
    if (activistSearchTerm.trim() === '') {
      setFilteredActivists(activistsList);
    } else {
      const filtered = activistsList.filter(activist =>
        activist.full_name.toLowerCase().includes(activistSearchTerm.toLowerCase())
      );
      setFilteredActivists(filtered);
    }
  }, [activistSearchTerm, activistsList]);
  
  // 🆕 useEffect لتحديث القوائم المفلترة عند تحميل البيانات
  useEffect(() => {
    setFilteredJournalists(journalistsList);
  }, [journalistsList]);

  useEffect(() => {
    setFilteredActivists(activistsList);
  }, [activistsList]);

  // 🔗 useEffect للبحث المتقدم في المؤسسات الأخرى (ربط مؤسسة بمؤسسة)
  useEffect(() => {
    if (institutionPeerSearchTerm.trim() === '') {
      setFilteredInstitutionPeers(institutionsList);
    } else {
      const filtered = institutionsList.filter(inst =>
        inst.title.toLowerCase().includes(institutionPeerSearchTerm.toLowerCase())
      );
      setFilteredInstitutionPeers(filtered);
    }
  }, [institutionPeerSearchTerm, institutionsList]);

  useEffect(() => {
    setFilteredInstitutionPeers(institutionsList);
  }, [institutionsList]);

  // 🔗 تحميل المؤسسات المرتبطة مسبقاً في وضع التعديل
  useEffect(() => {
    if (mode === 'edit' && institutionData && institutionsList.length > 0) {
      setTimeout(() => {
        if (institutionData.linked_institutions) {
          try {
            const linkedIds = Array.isArray(institutionData.linked_institutions)
              ? institutionData.linked_institutions
              : JSON.parse(institutionData.linked_institutions || '[]');

            const linkedPeers = linkedIds
              .map(id => institutionsList.find(inst => inst.id == id))
              .filter(Boolean)
              .filter(inst => inst.id != institutionData.id)
              .map(inst => ({ ...inst, isNew: false }));

            setSelectedInstitutionPeers(linkedPeers);
          } catch (e) {
            console.error("فشل في تحميل المؤسسات المرتبطة:", e);
          }
        }
      }, 500);
    }
  }, [mode, institutionData, institutionsList]);

  // 🔗 دوال التعامل مع ربط مؤسسة بمؤسسة أخرى (اختيار من الموجودين فقط)
  const handleSelectInstitutionPeer = (institutionId) => {
    const peer = institutionsList.find(inst => inst.id == institutionId);
    if (peer && !selectedInstitutionPeers.find(sel => sel.id == institutionId)) {
      setSelectedInstitutionPeers(prev => [...prev, { ...peer, isNew: false }]);
    }
  };

  const handleRemoveInstitutionPeer = (institutionId) => {
    setSelectedInstitutionPeers(prev => prev.filter(inst => inst.id !== institutionId));
  };
  
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
    // إزالة رسالة الخطأ للحقل عند تغييره
    setFormErrors(prev => {
      if (!prev) return {};
      const copy = { ...prev };
      if (copy[name]) delete copy[name];
      // إذا غيرنا نوع المسؤول، نزيل رسالة خطأ حقل نوع الشخص الجديد أيضاً
      if (name === 'responsible_type' && copy.new_person_type) delete copy.new_person_type;
      return copy;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // إذا تم تغيير الدولة، قم بإعادة تعيين المحافظة
    if (name === 'country' && value !== 'فلسطين') {
      setFormValues({
        ...formValues,
        [name]: value,
        country_province: '' // إعادة تعيين المحافظة
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: value
      });
    }
  };

  // Helper to jump to a field when clicking an error in the modal
  const jumpToField = (item) => {
    try {
      setShowErrorsModal(false);
      setTimeout(() => {
        setActiveTab(item.tabId);
        setTimeout(() => {
          let target = document.querySelector(`[name="${item.key}"]`);
          if (!target) {
            const tabPane = document.querySelector(`.tab-pane[aria-hidden="false"], .tab-pane.active`);
            target = tabPane ? tabPane.querySelector('.invalid-feedback.d-block') : document.querySelector('.invalid-feedback.d-block');
          }
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            try { target.focus && target.focus(); } catch (e) {}
          }
        }, 250);
      }, 200);
    } catch (e) {
      setShowErrorsModal(false);
    }
  };

  const handleAddToArray = (key, valueSetter, value) => {
    if (value.trim()) {
      setFormValues(prev => ({
        ...prev,
        [key]: [...prev[key], value.trim()]
      }));
      valueSetter('');
    }
  };

  const handleRemoveFromArray = (key, index) => {
    setFormValues(prev => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index)
    }));
  };

  const toggleMultiSelect = (value) => {
    const exists = formValues.representative_political_orientation.includes(value);
    const updated = exists
      ? formValues.representative_political_orientation.filter(v => v !== value)
      : [...formValues.representative_political_orientation, value];
    setFormValues({
      ...formValues,
      representative_political_orientation: updated
    });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages([...images, ...files]);
  };

  // 🆕 رفع ملفات الفيديو مع تتبع التقدم - يبدأ الرفع فوراً
  const handleVideoUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    const valid = files.filter(f => f.size <= 1024 * 1024 * 1024); // 1GB max
    
    for (const file of valid) {
      const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // إضافة الملف مع معرف مؤقت
      setVideoFiles(prev => [...prev, { tempId, file, name: file.name, size: file.size, status: 'uploading' }]);
      setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 0, status: 'uploading' } }));
      
      // بدء الرفع
      const fd = new FormData();
      fd.append('video', file);
      
      try {
        const res = await api.post('/upload-video', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setVideoUploading(prev => ({ ...prev, [tempId]: { progress: percent, status: 'uploading' } }));
          }
        });
        
        // نجح الرفع - استبدال الملف المؤقت بالاسم النهائي
        const uploadedName = res.data.name;
        setVideoFiles(prev => prev.map(v => 
          v.tempId === tempId ? uploadedName : v
        ));
        setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 100, status: 'done' } }));
      } catch (err) {
        console.error('فشل رفع الفيديو:', err);
        setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 0, status: 'error', message: err.response?.data?.message || 'فشل رفع الفيديو' } }));
        // إزالة الملف الفاشل من القائمة
        setVideoFiles(prev => prev.filter(v => v.tempId !== tempId));
      }
    }
    
    // تنظيف حقل الإدخال
    if (videoInputRef.current) videoInputRef.current.value = null;
  };

  // ✅ دالة رفع الملفات - محدثة لاستخدام api
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await api.post('/upload-file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data.name;
    } catch (error) {
      console.error('فشل رفع الملف:', error);
      return null;
    }
  };

  // 🆕 تحقق من اكتمال رفع جميع الفيديوهات
  const areAllVideosUploaded = () => {
    return videoFiles.every(v => typeof v === 'string');
  };

  // 🆕 الحصول على أسماء الفيديوهات المرفوعة فقط
  const getUploadedVideoNames = () => {
    return videoFiles.filter(v => typeof v === 'string');
  };

  // ✅ دالة الإرسال - محدثة لاستخدام api
  const handleSubmit = async (e) => {
    e.preventDefault();
    // فحص التكرار قبل الحفظ
    const matches = await checkBeforeSave(formValues.title);
    if (matches && matches.length > 0) {
      setShowDuplicateConfirm(true);
      return;
    }
    doActualSubmit();
  };

  const doActualSubmit = async () => {
    setIsSubmitting(true);
    try {
      // 🆕 التحقق من اكتمال رفع الفيديوهات
      if (!areAllVideosUploaded()) {
        alert('يرجى انتظار اكتمال رفع جميع ملفات الفيديو');
        setIsSubmitting(false);
        return;
      }

      // 1. رفع اللوجو
      let uploadedLogo = formValues.logo || '';
      if (logo && typeof logo !== 'string') {
        uploadedLogo = await uploadFile(logo);
      }

      // 2. رفع صورة المسؤول
      let uploadedRepresentativeImage = formValues.representative_profile_image || '';
      if (representativeImage && typeof representativeImage !== 'string') {
        uploadedRepresentativeImage = await uploadFile(representativeImage);
      }

      // 3. رفع الصور العادية
      const uploadedImages = await Promise.all(
        images.map(file => typeof file === 'string' ? file : uploadFile(file))
      );

      // 4. رفع المرفقات
      const uploadedAttachments = await Promise.all(
        (formValues.attachments || []).map(file =>
          typeof file === 'string' ? file : uploadFile(file)
        )
      );

      // 🆕 5. الفيديوهات (تم رفعها مسبقاً - نأخذ الأسماء المرفوعة فقط)
      const finalVideoFiles = getUploadedVideoNames();

      const finalImages = uploadedImages.filter(Boolean);
      const finalAttachments = uploadedAttachments.filter(Boolean);

      // 6. تجهيز البيانات للإرسال
      // تحقق من الحقول الإلزامية محلياً
      const localErrors = {};
      
      // 🆕 لا توجد validation للمسؤول - يمكن إنشاء مؤسسة بدون مسؤول
      // تم إزالة جميع التحققات المتعلقة بالمسؤول لإتاحة إنشاء المؤسسات بحرية أكبر
      
      if (Object.keys(localErrors).length > 0) {
        setFormErrors(localErrors);
        setIsSubmitting(false);

        // بناء قائمة الأخطاء لعرضها في المودال
        const fieldTabMap = {
          title: '1', license_status: '1', reference: '1', orientation: '1', description: '1', logo: '1',
          responsible_journalist_id: '2', responsible_activist_id: '2', new_person_type: '2', representative_profile_image: '2', representative_name: '2', representative_gender: '2',
          country: '3', country_province: '3', city_or_area: '3', address_details: '3', map_address: '3',
          whatsapp1: '4', phone_fax: '4', mobile1: '4', email: '4', website: '4',
          images: '5', attachments: '5'
        };

        const humanLabels = {
          new_person_type: 'نوع الشخص',
          representative_profile_image: 'صورة المسؤول',
          representative_name: 'اسم الممثل',
        };

        const list = Object.keys(localErrors).map(k => ({
          key: k,
          message: (localErrors[k] && localErrors[k][0]) || 'حقل مطلوب',
          tabId: fieldTabMap[k] || '1',
          label: humanLabels[k] || k
        }));

        setErrorsList(list);
        setShowErrorsModal(true);
        return;
      }

      // 🔗 المؤسسات الأخرى المرتبطة (اختيار من الموجودين فقط، لا يوجد "جديد")
      const finalInstitutionPeerIds = selectedInstitutionPeers
        .map(inst => inst.id ? String(inst.id) : null)
        .filter(Boolean);

      const dataToSend = {
        ...formValues,
        logo: uploadedLogo, // 🆕
        representative_profile_image: uploadedRepresentativeImage, // 🆕
        whatsapp1: formValues.whatsapp1_number ? `${formValues.whatsapp1_code}${formValues.whatsapp1_number}` : null,
        phone_fax: formValues.phone_fax || '',
        oreedo_number: formValues.oreedo_number || '',
        representative_political_orientation: JSON.stringify(formValues.representative_political_orientation),
        youtube_links: JSON.stringify(formValues.youtube_links),
        representative_statements: JSON.stringify(formValues.statements),
        social_accounts: JSON.stringify(formValues.social_accounts),
        images: JSON.stringify(finalImages),
        attachments: JSON.stringify(finalAttachments),
        video_files: JSON.stringify(finalVideoFiles), // 🆕 ملفات فيديو
        linked_institutions: JSON.stringify(finalInstitutionPeerIds), // 🔗 مؤسسات أخرى مرتبطة
      };

      // ✅ الإرسال باستخدام api
      let institutionResponse;
      if (mode === 'edit') {
        institutionResponse = await api.put(`/institutions/${institutionData.id}`, dataToSend);
      } else {
        institutionResponse = await api.post("/institutions", dataToSend);
      }

      // ✅ التحقق من طلب الموافقة (data_entry)
      if (institutionResponse.data?.pending) {
        setFormErrors({});
        alert('تم إرسال طلبك للمراجعة من قبل المسؤول. سيتم إشعارك عند اتخاذ القرار.');
        window.location.href = '/dashboard/my-requests';
        return;
      }

      // 🔗 مزامنة ثنائية الاتجاه لربط مؤسسة بمؤسسة أخرى (تعمل بحالتي الإنشاء والتعديل معاً)
      const currentInstitutionId = mode === 'edit'
        ? institutionData.id
        : (institutionResponse.data?.id || institutionResponse.data?.data?.id);

      if (currentInstitutionId && finalInstitutionPeerIds.length > 0) {
        for (const peerId of finalInstitutionPeerIds) {
          try {
            const peerResponse = await api.get(`/institutions/${peerId}`);
            const peerData = peerResponse.data?.data || peerResponse.data;

            const peerLinkedInstitutions = peerData.linked_institutions
              ? JSON.parse(peerData.linked_institutions)
              : [];

            if (!peerLinkedInstitutions.includes(String(currentInstitutionId))) {
              peerLinkedInstitutions.push(String(currentInstitutionId));

              // ملاحظة: نرسل title + حقول المسؤول الحالية كما هي (لتفادي أن يقوم الباك-إند
              // بمسح responsible_journalist_id/responsible_activist_id تلقائياً عند غيابها
              // عن الطلب — راجع cleanResponsibleData بالـ InstitutionController) + الحقل المطلوب تحديثه فقط
              await api.put(`/institutions/${peerId}`, {
                title: peerData.title,
                responsible_type: peerData.responsible_type,
                responsible_journalist_id: peerData.responsible_journalist_id,
                responsible_activist_id: peerData.responsible_activist_id,
                linked_institutions: JSON.stringify(peerLinkedInstitutions)
              });

              console.log(`✅ تم ربط المؤسسة ${peerId} بالمؤسسة ${currentInstitutionId}`);
            }
          } catch (error) {
            console.error(`❌ فشل في ربط المؤسسة ${peerId}:`, error);
          }
        }
      }

      setFormErrors({});
      alert(mode === 'edit' ? "تم تحديث المؤسسة بنجاح" : "تم إضافة المؤسسة بنجاح");
      window.location.href = "/dashboard/institutions";

    } catch (error) {
      console.log("=== تفاصيل الخطأ ===");
      console.log("Status:", error.response?.status);
      console.log("Data:", error.response?.data);
      console.log("Full Error:", error);
      
      if (error.response?.status === 422) {
        // تحويل أخطاء السيرفر إلى نفس واجهة المودال لسهولة التنقل
        const serverErrors = error.response.data.errors || {};
        setFormErrors(serverErrors);

        const list = Object.keys(serverErrors).map(k => ({
          key: k,
          message: (serverErrors[k] && serverErrors[k][0]) || 'حقل مطلوب',
          tabId: fieldTabMap[k] || '1',
          label: humanLabels[k] || k
        }));
        setErrorsList(list);
        // مجموع الأخطاء في كل تبويب
        const perTab = {};
        list.forEach(it => { perTab[it.tabId] = (perTab[it.tabId] || 0) + 1; });
        setErrorsPerTab(perTab);
        setShowErrorsModal(true);
      } else {
        console.error("فشل في الحفظ", error);
        alert("فشل في حفظ البيانات: " + (error.response?.data?.message || error.message));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderRadioGroup = (name, options) => (
    <div className="d-flex gap-4">
      {options.map(opt => (
        <div key={opt} className="form-check form-check-primary mb-0 radio-option-lg">
          <input
            className="form-check-input"
            type="radio"
            name={name}
            id={`${name}_${opt}`}
            value={opt}
            checked={formValues[name] === opt}
            onChange={handleRadioChange}
          />
          <label className="form-check-label ms-0" htmlFor={`${name}_${opt}`}>
            {opt}
          </label>
        </div>
      ))}
    </div>
  );

  // ✅ دالة مساعدة لعرض الصور مع FILE_BASE_URL
  const getImageUrl = (imageName) => {
    if (!imageName) return null;
    if (imageName.startsWith('http')) return imageName;
    return `${FILE_BASE_URL}/storage/uploads/${imageName}`;
  };

  const renderFileMeta = (fileName, fileType) => {
    let icon = 'fas fa-file', color = 'text-secondary', label = 'ملف';
    const lower = (fileName || '').toLowerCase();
    if (lower.endsWith('.pdf')) { icon = 'fas fa-file-pdf'; color = 'text-danger'; label = 'PDF'; }
    else if (lower.endsWith('.xls') || lower.endsWith('.xlsx')) { icon = 'fas fa-file-excel'; color = 'text-success'; label = 'Excel'; }
    else if (lower.endsWith('.doc') || lower.endsWith('.docx')) { icon = 'fas fa-file-word'; color = 'text-primary'; label = 'Word'; }
    else if (lower.endsWith('.ppt') || lower.endsWith('.pptx')) { icon = 'fas fa-file-powerpoint'; color = 'text-warning'; label = 'PowerPoint'; }
    else if (lower.endsWith('.txt')) { icon = 'fas fa-file-alt'; color = 'text-info'; label = 'نص'; }
    return { icon, color, label };
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">{mode === 'edit' ? 'تحديث مؤسسة' : 'إضافة مؤسسة جديدة'}</CardTitle>
          <Nav tabs className="nav-tabs-custom">
            {[1, 2, 3, 4, 5].map(num => (
              <NavItem key={num}>
                <NavLink className={classnames({ active: activeTab === `${num}` })} onClick={() => toggleTab(`${num}`)}>
                  {['حول المؤسسة', 'مسؤول المؤسسة', 'العنوان', 'الاتصال', 'مرفقات'][num - 1]}
                  {errorsPerTab[`${num}`] ? (
                    <Badge color="danger" pill style={{ marginLeft: 8 }}>{errorsPerTab[`${num}`]}</Badge>
                  ) : null}
                </NavLink>
              </NavItem>
            ))}
          </Nav>

          {/* ملخص سريع للأخطاء (إذا وجدت) */}
          {Object.keys(errorsPerTab || {}).length > 0 && Object.values(errorsPerTab).reduce((a,b)=>a+b,0) > 0 && (
            <div className="alert alert-warning mt-3 d-flex align-items-center justify-content-between">
              <div>
                <strong>هناك أخطاء في بعض الحقول —</strong>
                <span className="ms-2">انقر على الزر لعرض الحقول المفقودة والتنقل إليها.</span>
              </div>
              <div>
                <Button color="warning" onClick={() => setShowErrorsModal(true)}>عرض الحقول المفقودة</Button>
              </div>
            </div>
          )}

          <Form className="mt-4" onSubmit={handleSubmit}>
            <TabContent activeTab={activeTab}>
              
              <TabPane tabId="1" data-tab-id="1">
  {/* ✅ المعلومات الأساسية للمؤسسة */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-building me-2"></i>
        المعلومات الأساسية للمؤسسة
      </h5>
    </div>
    <Row className="g-4"> 
      {/* اسم المؤسسة */}
      <Col md={4}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            اسم المؤسسة <span className="text-danger">*</span>
          </Label>
          <Input
            name="title"
            value={formValues.title}
            onChange={(e) => { handleChange(e); handleNameChange(e.target.value); }}
            onBlur={handleNameBlur}
            className={`form-control-lg border-2 ${formErrors.title ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder="أدخل اسم المؤسسة"
            required
          />
          {formErrors.title && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.title[0]}</div>
          )}
          <DuplicateWarning matches={duplicateWarning} checking={checkingDuplicate} error={duplicateError} onDismiss={dismissWarning} />
        </div>
      </Col>

      {/* حالة الترخيص */}
      <Col md={2}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">حالة الترخيص</Label>
          <div className="d-flex gap-3 mt-2">
            {['مرخص', 'غير مرخص'].map(status => (
              <div key={status} className="form-check">
                <input
                  className="form-check-input fs-5"
                  type="radio"
                  name="license_status"
                  id={`license_status_${status}`}
                  value={status}
                  checked={formValues.license_status === status}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor={`license_status_${status}`}>
                  {status}
                </label>
              </div>
            ))}
          </div>
          {formErrors.license_status && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.license_status[0]}</div>
          )}
        </div>
      </Col>

      {/* مرجعية المؤسسة */}
      <Col md={3}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">مرجعية المؤسسة</Label>
          <div className="d-flex gap-3 mt-2">
            {['محلي', 'خارجية'].map(ref => (
              <div key={ref} className="form-check">
                <input
                  className="form-check-input fs-5"
                  type="radio"
                  name="reference"
                  id={`reference_${ref}`}
                  value={ref}
                  checked={formValues.reference === ref}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor={`reference_${ref}`}>
                  {ref}
                </label>
              </div>
            ))}
          </div>
          {formErrors.reference && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.reference[0]}</div>
          )}
        </div>
      </Col>

      {/* توجه المؤسسة */}
      <Col md={3}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">توجه المؤسسة</Label>
          <div className="d-flex gap-2 flex-wrap">
            {['مؤيد', 'معارض', 'محايد'].map(orientation => (
              <div key={orientation} className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="orientation"
                  id={`orientation_${orientation}`}
                  value={orientation}
                  checked={formValues.orientation === orientation}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label fw-semibold text-dark ms-2" htmlFor={`orientation_${orientation}`}>
                  {orientation}
                </label>
              </div>
            ))}
          </div>
          {formErrors.orientation && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.orientation[0]}</div>
          )}
        </div>
      </Col>
    </Row>
  </div>

  {/* ✅ وصف المؤسسة */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-success fw-bold mb-0">
        <i className="fas fa-file-alt me-2"></i>
        حول المؤسسة
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      <div className="editor-container" style={{ minHeight: '350px', width: '100%' }}>
        <Editor
          apiKey="s63csl3mxs9qcpfxz7ti9a4mx3zjto2mof448ll6atc7kxvi"
          value={formValues.description}
          init={{
            height: 350,
            width: '100%',
            menubar: 'file edit view insert format tools table help',
            directionality: 'rtl',
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'help', 'wordcount'
            ],
            toolbar: 'undo redo | blocks fontfamily fontsize | forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | removeformat | help',
            font_family_formats: 'Arial=arial,helvetica,sans-serif; Times New Roman=times new roman,times,serif; Courier New=courier new,courier,monospace; Tahoma=tahoma,arial,helvetica,sans-serif; Verdana=verdana,arial,helvetica,sans-serif; Georgia=georgia,serif',
            font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 20pt 24pt 26pt 36pt',
            toolbar_mode: 'sliding',
            branding: false,
            resize: true,
            statusbar: true,
            content_style: 'body { font-family: Tahoma, Arial, sans-serif; font-size: 16px; direction: rtl; }'
          }}
          onEditorChange={(content) => setFormValues({ ...formValues, description: content })}
        />
      </div>
      {formErrors.description && (
        <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.description[0]}</div>
      )}
    </div>
  </div>

  {/* ✅ لوجو المؤسسة */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-secondary fw-bold mb-0">
        <i className="fas fa-image me-2"></i>
        لوجو المؤسسة
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      <Row className="g-4 align-items-center">
        <Col md={6}>
          <div className="border-2 border-dashed border-secondary rounded-3 p-4 text-center">
            <Input
              type="file"
              accept="image/*"
              onChange={handleLogoUpload}
              className={`form-control-lg border-0 ${formErrors.logo ? 'is-invalid' : ''}`}
              innerRef={logoInputRef}
            />
            <div className="mt-2 text-muted">
              <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
              <p className="mb-0">اختر لوجو المؤسسة</p>
              <small>PNG, JPG, JPEG حتى 2MB</small>
            </div>
            {formErrors.logo && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.logo[0]}</div>
            )}
          </div>
        </Col>
        
        {(logo || formValues.logo) && (
          <Col md={6}>
            <div className="text-center">
              <div className="position-relative d-inline-block">
                <img
src={logo ? URL.createObjectURL(logo) : `${FILE_BASE_URL}/uploads/images/${formValues.logo}`}                  alt="لوجو المؤسسة"
                  className="img-fluid rounded border border-3 border-light shadow-lg"
                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                />
                <div className="position-absolute top-0 end-0">
                  <Button
                    color="danger"
                    size="sm"
                    onClick={() => {
                      setLogo(null);
                      setFormValues(prev => ({...prev, logo: ''}));
                      if (logoInputRef.current) logoInputRef.current.value = null;
                    }}
                    className="rounded-circle fw-semibold"
                    style={{ width: '35px', height: '35px' }}
                  >
                    <i className="fas fa-times"></i>
                  </Button>
                </div>
              </div>
              <p className="mt-3 text-success fw-medium">
                <i className="fas fa-check-circle me-1"></i>
                تم رفع اللوجو بنجاح
              </p>
            </div>
          </Col>
        )}
      </Row>
    </div>

    {/* 🔗 الربط مع مؤسسات أخرى */}
    <Row className="g-4 mt-1">
      <Col md={12}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-sitemap me-2 text-primary"></i>
            الربط مع مؤسسات أخرى
          </Label>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-primary"></i>
              ابحث عن مؤسسة:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن مؤسسة (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-primary mb-2"
              value={institutionPeerSearchTerm}
              onChange={(e) => setInstitutionPeerSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء المؤسسات</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectInstitutionPeer(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-primary"
              size="5"
            >
              <option value="">-- اختر مؤسسة --</option>
              {Array.isArray(filteredInstitutionPeers) && filteredInstitutionPeers
                .filter(inst => !institutionData || inst.id != institutionData.id)
                .filter(inst => !selectedInstitutionPeers.find(sel => sel.id == inst.id))
                .map(inst => (
                  <option key={inst.id} value={inst.id}>{inst.title}</option>
                ))}
            </Input>
            {institutionPeerSearchTerm && filteredInstitutionPeers.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{institutionPeerSearchTerm}"
              </small>
            )}
            {institutionPeerSearchTerm && filteredInstitutionPeers.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredInstitutionPeers.length} مؤسسة
              </small>
            )}
          </div>

          {selectedInstitutionPeers.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">المؤسسات المختارة:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedInstitutionPeers.map(inst => (
                  <Badge
                    key={inst.id}
                    color="primary"
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className="fas fa-building me-1"></i>
                    {inst.title}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveInstitutionPeer(inst.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
            </div>
          )}

          {formErrors.linked_institutions && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_institutions[0]}</div>
          )}
        </div>
      </Col>
    </Row>
  </div>
</TabPane>
              <TabPane tabId="2" data-tab-id="2">
  {/* ✅ مسؤول المؤسسة */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-user-tie me-2"></i>
        مسؤول المؤسسة
      </h5>
    </div>
    
    {/* الصف الأول: نوع المسؤول + نوع الشخص الجديد (إذا اختار شخص جديد) + صورة المسؤول */}
    <Row className="g-4 mb-5">
      {/* نوع المسؤول - ثلث الصف */}
      <Col lg={4}>
        <div className="mb-3 pb-2 border-bottom border-warning">
          <h6 className="text-warning fw-bold mb-0">
            <i className="fas fa-user-check me-2"></i>
            نوع المسؤول
          </h6>
        </div>
        <div className="p-4 border rounded-3 shadow-sm bg-white h-100">
          <p className="text-muted mb-3">اختر نوع المسؤول عن المؤسسة</p>
          <div className="d-flex flex-column gap-3">
            <div className="form-check form-check-primary mb-0 radio-option-lg">
              <input
                className="form-check-input fs-5"
                type="radio"
                name="responsible_type"
                id="responsible_type_journalist"
                value="existing_journalist"
                checked={formValues.responsible_type === 'existing_journalist'}
                onChange={handleRadioChange}
              />
              <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor="responsible_type_journalist">
                <i className="fas fa-newspaper me-2 text-primary"></i>
                صحفي موجود
              </label>
            </div>
            <div className="form-check form-check-primary mb-0 radio-option-lg">
              <input
                className="form-check-input fs-5"
                type="radio"
                name="responsible_type"
                id="responsible_type_activist"
                value="existing_activist"
                checked={formValues.responsible_type === 'existing_activist'}
                onChange={handleRadioChange}
              />
              <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor="responsible_type_activist">
                <i className="fas fa-fist-raised me-2 text-success"></i>
                ناشط موجود
              </label>
            </div>
            <div className="form-check form-check-primary mb-0 radio-option-lg">
              <input
                className="form-check-input fs-5"
                type="radio"
                name="responsible_type"
                id="responsible_type_new"
                value="new_person"
                checked={formValues.responsible_type === 'new_person'}
                onChange={handleRadioChange}
              />
              <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor="responsible_type_new">
                <i className="fas fa-user-plus me-2 text-info"></i>
                شخص جديد
              </label>
            </div>
          </div>
        </div>
      </Col>

      {/* اختيار الصحفي الموجود - ثلث الصف */}
      {formValues.responsible_type === 'existing_journalist' && (
        <Col lg={4}>
          <div className="mb-3 pb-2 border-bottom border-primary">
            <h6 className="text-primary fw-bold mb-0">
              <i className="fas fa-newspaper me-2"></i>
              اختيار الصحفي المسؤول
            </h6>
          </div>
          <div className="p-4 border rounded-3 shadow-sm bg-white h-100">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-search me-2 text-primary"></i>
              البحث والاختيار
            </Label>
            
            {/* البحث المتقدم */}
            <div className="mb-3">
              <Input
                type="text"
                placeholder="ابحث عن صحفي (اكتب اسم أو جزء منه)..."
                className="form-control border-2 border-primary"
                value={journalistSearchTerm}
                onChange={(e) => setJournalistSearchTerm(e.target.value)}
              />
              <small className="text-muted">اكتب للبحث السريع في الأسماء</small>
            </div>

            {/* القائمة العادية */}
            <div>
              <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
              <Input
                type="select"
                name="responsible_journalist_id"
                value={formValues.responsible_journalist_id}
                onChange={handleChange}
                className={`form-control-lg border-2 ${formErrors.responsible_journalist_id ? 'is-invalid border-danger' : 'border-primary'}`}
                size="5"
              >
                <option value="">-- اختر الصحفي المسؤول --</option>
                {filteredJournalists.map(journalist => (
                  <option key={journalist.id} value={journalist.id}>
                    {journalist.full_name}
                  </option>
                ))}
              </Input>
              {formErrors.responsible_journalist_id && (
                <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.responsible_journalist_id[0]}</div>
              )}
              {journalistSearchTerm && filteredJournalists.length === 0 && (
                <small className="text-warning d-block mt-2">
                  <i className="fas fa-exclamation-triangle me-1"></i>
                  لا توجد نتائج للبحث "{journalistSearchTerm}"
                </small>
              )}
              {journalistSearchTerm && filteredJournalists.length > 0 && (
                <small className="text-success d-block mt-2">
                  <i className="fas fa-check-circle me-1"></i>
                  تم العثور على {filteredJournalists.length} صحفي
                </small>
              )}
            </div>
          </div>
        </Col>
      )}

      {/* اختيار الناشط الموجود - ثلث الصف */}
      {formValues.responsible_type === 'existing_activist' && (
        <Col lg={4}>
          <div className="mb-3 pb-2 border-bottom border-success">
            <h6 className="text-success fw-bold mb-0">
              <i className="fas fa-fist-raised me-2"></i>
              اختيار الناشط المسؤول
            </h6>
          </div>
          <div className="p-4 border rounded-3 shadow-sm bg-white h-100">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-search me-2 text-success"></i>
              البحث والاختيار
            </Label>
            
            {/* البحث المتقدم */}
            <div className="mb-3">
              <Input
                type="text"
                placeholder="ابحث عن ناشط (اكتب اسم أو جزء منه)..."
                className="form-control border-2 border-success"
                value={activistSearchTerm}
                onChange={(e) => setActivistSearchTerm(e.target.value)}
              />
              <small className="text-muted">اكتب للبحث السريع في الأسماء</small>
            </div>

            {/* القائمة العادية */}
            <div>
              <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
              <Input
                type="select"
                name="responsible_activist_id"
                value={formValues.responsible_activist_id}
                onChange={handleChange}
                className={`form-control-lg border-2 ${formErrors.responsible_activist_id ? 'is-invalid border-danger' : 'border-success'}`}
                size="5"
              >
                <option value="">-- اختر الناشط المسؤول --</option>
                {filteredActivists.map(activist => (
                  <option key={activist.id} value={activist.id}>
                    {activist.full_name}
                  </option>
                ))}
              </Input>
              {formErrors.responsible_activist_id && (
                <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.responsible_activist_id[0]}</div>
              )}
              {activistSearchTerm && filteredActivists.length === 0 && (
                <small className="text-warning d-block mt-2">
                  <i className="fas fa-exclamation-triangle me-1"></i>
                  لا توجد نتائج للبحث "{activistSearchTerm}"
                </small>
              )}
              {activistSearchTerm && filteredActivists.length > 0 && (
                <small className="text-success d-block mt-2">
                  <i className="fas fa-check-circle me-1"></i>
                  تم العثور على {filteredActivists.length} ناشط
                </small>
              )}
            </div>
          </div>
        </Col>
      )}

      {/* نوع الشخص الجديد - ثلث الصف (يظهر فقط عند اختيار شخص جديد) */}
      {formValues.responsible_type === 'new_person' && (
        <Col lg={4}>
          <div className="mb-3 pb-2 border-bottom border-warning">
            <h6 className="text-warning fw-bold mb-0">
              <i className="fas fa-user-tag me-2"></i>
              نوع الشخص الجديد
            </h6>
          </div>
          <div className="p-4 border rounded-3 shadow-sm bg-white h-100">
            <p className="text-muted mb-3">حدد نوع الشخص الذي تريد إنشاؤه</p>
            <div className={`d-flex flex-column gap-3 ${formErrors.new_person_type ? 'border border-danger rounded p-2' : ''}`}>
              <div className="form-check form-check-warning mb-0 radio-option-lg">
                <input
                  className={`form-check-input fs-5 ${formErrors.new_person_type ? 'is-invalid' : ''}`}
                  type="radio"
                  name="new_person_type"
                  id="new_person_type_activist"
                  value="activist"
                  checked={formValues.new_person_type === 'activist'}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor="new_person_type_activist">
                  <i className="fas fa-fist-raised me-2 text-success"></i>
                  ناشط
                </label>
              </div>
              <div className="form-check form-check-warning mb-0 radio-option-lg">
                <input
                  className={`form-check-input fs-5 ${formErrors.new_person_type ? 'is-invalid' : ''}`}
                  type="radio"
                  name="new_person_type"
                  id="new_person_type_journalist"
                  value="journalist"
                  checked={formValues.new_person_type === 'journalist'}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor="new_person_type_journalist">
                  <i className="fas fa-newspaper me-2 text-primary"></i>
                  صحفي
                </label>
              </div>
            </div>
            {formErrors.new_person_type && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.new_person_type[0]}</div>
            )}
          </div>
        </Col>
      )}

      {/* صورة المسؤول - ثلث الصف (يظهر فقط عند اختيار شخص جديد) */}
      {formValues.responsible_type === 'new_person' && (
        <Col lg={4}>
          <div className="mb-3 pb-2 border-bottom border-info">
            <h6 className="text-info fw-bold mb-0">
              <i className="fas fa-camera me-2"></i>
              صورة المسؤول
            </h6>
          </div>
          <div className="p-4 border rounded-3 shadow-sm bg-white h-100">
            <div className="text-center">
              {(representativeImage || formValues.representative_profile_image) ? (
                <div className="position-relative d-inline-block mb-3">
                  <img
                    src={representativeImage ? URL.createObjectURL(representativeImage) : `${FILE_BASE_URL}/uploads/images/${formValues.representative_profile_image}`}
                    alt="صورة المسؤول"
                    className="img-fluid rounded-circle border border-3 border-light shadow-lg"
                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                  />
                  <div className="position-absolute top-0 end-0">
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        setRepresentativeImage(null);
                        setFormValues(prev => ({...prev, representative_profile_image: ''}));
                        if (representativeImageRef.current) representativeImageRef.current.value = null;
                      }}
                      className="rounded-circle fw-semibold"
                      style={{ width: '30px', height: '30px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="border-2 border-dashed border-info rounded-3 p-3 mb-3">
                  <i className="fas fa-cloud-upload-alt fa-2x mb-2 text-info"></i>
                  <p className="mb-0 text-muted">اختر صورة المسؤول</p>
                  <small className="text-muted">PNG, JPG, JPEG حتى 2MB</small>
                </div>
              )}
              
              <Input
                type="file"
                accept="image/*"
                onChange={handleRepresentativeImageUpload}
                className={`form-control border-2 ${formErrors.representative_profile_image ? 'is-invalid border-danger' : 'border-info'}`}
                innerRef={representativeImageRef}
              />
              
              {formErrors.representative_profile_image && (
                <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.representative_profile_image[0]}</div>
              )}
              
              {(representativeImage || formValues.representative_profile_image) && (
                <p className="mt-2 text-success fw-medium mb-0">
                  <i className="fas fa-check-circle me-1"></i>
                  تم رفع الصورة بنجاح
                </p>
              )}
            </div>
          </div>
        </Col>
      )}
    </Row>

    {/* الصف الثاني: المعلومات الأساسية للشخص الجديد */}
    {formValues.responsible_type === 'new_person' && (
      <Row className="g-4">
        <Col lg={12}>
          <div className="mb-3 pb-2 border-bottom border-secondary">
            <h6 className="text-secondary fw-bold mb-0">
              <i className="fas fa-id-card me-2"></i>
              المعلومات الأساسية
            </h6>
          </div>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Row className="g-4">
              {/* اسم المسؤول */}
              <Col lg={6}>
                <Label className="form-label fw-bold mb-3 text-dark d-block">
                  اسم الممثل عن المؤسسة
                </Label>
                <Input
                  name="representative_name"
                  value={formValues.representative_name}
                  onChange={handleChange}
                  placeholder="الاسم الكامل"
                  className={`form-control-lg border-2 ${formErrors.representative_name ? 'is-invalid border-danger' : 'border-secondary'}`}
                />
                {formErrors.representative_name && (
                  <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.representative_name[0]}</div>
                )}
              </Col>

              {/* رقم الهوية */}
              <Col lg={6}>
                <Label className="form-label fw-bold mb-3 text-dark d-block">رقم الهوية</Label>
                <Input
                  name="representative_id_number"
                  value={formValues.representative_id_number}
                  onChange={handleChange}
                  placeholder="رقم الهوية"
                  className={`form-control-lg border-2 ${formErrors.representative_id_number ? 'is-invalid border-danger' : 'border-secondary'}`}
                />
                {formErrors.representative_id_number && (
                  <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.representative_id_number[0]}</div>
                )}
              </Col>

              {/* الجنس */}
              <Col lg={4}>
                <Label className="form-label fw-bold mb-3 text-dark d-block">الجنس</Label>
                <div className="d-flex gap-3 mt-2">
                  {['ذكر', 'أنثى'].map(gender => (
                    <div key={gender} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="representative_gender"
                        id={`representative_gender_${gender}`}
                        value={gender}
                        checked={formValues.representative_gender === gender}
                        onChange={handleRadioChange}
                      />
                      <label className="form-check-label fw-semibold text-dark ms-2" htmlFor={`representative_gender_${gender}`}>
                        {gender}
                      </label>
                    </div>
                  ))}
                </div>
                {formErrors.representative_gender && (
                  <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.representative_gender[0]}</div>
                )}
              </Col>

              {/* تاريخ الميلاد */}
              <Col lg={4}>
                <Label className="form-label fw-bold mb-3 text-dark d-block">تاريخ الميلاد</Label>
                <Input
                  type="date"
                  name="representative_birthdate"
                  value={formValues.representative_birthdate}
                  onChange={handleChange}
                  className={`form-control-lg border-2 ${formErrors.representative_birthdate ? 'is-invalid border-danger' : 'border-secondary'}`}
                />
                {formErrors.representative_birthdate && (
                  <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.representative_birthdate[0]}</div>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    )}
  </div>
</TabPane>

             <TabPane tabId="3" data-tab-id="3">
  {/* ✅ معلومات العنوان والموقع */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-map-marker-alt me-2"></i>
        معلومات العنوان والموقع
      </h5>
    </div>
    
    {/* الصف الأول - الدولة والمحافظة والمدينة في صف واحد */}
    <Row className="g-4 mb-4">
      {/* الدولة */}
      <Col md={4}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            الدولة <span className="text-danger">*</span>
          </Label>
          <Input
            type="select"
            name="country"
            value={formValues.country}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.country ? 'is-invalid border-danger' : 'border-primary'}`}
          >
            <option value="فلسطين">فلسطين</option>
            <option value="الأردن">الأردن</option>
            <option value="لبنان">لبنان</option>
            <option value="سوريا">سوريا</option>
            <option value="مصر">مصر</option>
            <option value="السعودية">السعودية</option>
            <option value="الإمارات">الإمارات</option>
            <option value="قطر">قطر</option>
            <option value="الكويت">الكويت</option>
            <option value="العراق">العراق</option>
            <option value="المغرب">المغرب</option>
            <option value="الجزائر">الجزائر</option>
            <option value="تونس">تونس</option>
            <option value="ليبيا">ليبيا</option>
            <option value="السودان">السودان</option>
            <option value="اليمن">اليمن</option>
            <option value="عمان">عمان</option>
            <option value="البحرين">البحرين</option>
            <option value="أخرى">أخرى</option>
          </Input>
          {formErrors.country && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.country[0]}</div>
          )}
        </div>
      </Col>

      {/* المحافظة - يظهر فقط إذا كانت الدولة فلسطين */}
      {formValues.country === 'فلسطين' && (
        <Col md={4}>
          <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              المحافظة <span className="text-danger">*</span>
            </Label>
            <Input
              type="select"
              name="country_province"
              value={formValues.country_province}
              onChange={handleChange}
              className={`form-control-lg border-2 ${formErrors.country_province ? 'is-invalid border-danger' : 'border-primary'}`}
            >
              <option value="">-- اختر المحافظة --</option>
              {[
                "اريحا", "الخليل", "القدس", "بيت لحم", "جنين",
                "رام الله", "سلفيت", "طوباس", "طولكرم", "غزة", "قلقيلية", "نابلس"
              ].map((province) => (
                <option key={province} value={province}>{province}</option>
              ))}
            </Input>
            {formErrors.country_province && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.country_province[0]}</div>
            )}
          </div>
        </Col>
      )}

      {/* المدينة / القرية / المخيم */}
      <Col md={formValues.country === 'فلسطين' ? 4 : 8}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            {formValues.country === 'فلسطين' ? 'المدينة / القرية / المخيم' : 'المدينة / المنطقة'} <span className="text-danger">*</span>
          </Label>
          <Input
            name="city_or_area"
            value={formValues.city_or_area}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.city_or_area ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder={formValues.country === 'فلسطين' ? 'أدخل اسم المدينة أو القرية أو المخيم' : 'أدخل اسم المدينة أو المنطقة'}
          />
          {formErrors.city_or_area && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.city_or_area[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* الصف الثاني - تفاصيل العنوان */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-home me-2 text-success"></i>
          تفاصيل إضافية للعنوان
        </Label>
        <Input
          type="textarea"
          rows="3"
          name="address_details"
          value={formValues.address_details}
          onChange={handleChange}
          className={`form-control-lg border-2 ${formErrors.address_details ? 'is-invalid border-danger' : 'border-success'}`}
          placeholder="أدخل تفاصيل العنوان مثل: رقم البناية، اسم الشارع، معالم قريبة..."
        />
        {formErrors.address_details && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.address_details[0]}</div>
        )}
      </div>
    </div>

    {/* الموقع الجغرافي */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-globe me-2 text-info"></i>
          الموقع الجغرافي على الخريطة
        </Label>
        
        <Row className="g-3 mb-3">
          <Col md={8}>
            <Input
              name="map_address"
              value={formValues.map_address}
              readOnly
              className={`form-control-lg border-2 ${formErrors.map_address ? 'is-invalid border-danger' : 'border-info'} bg-light`}
              placeholder="سيتم تحديد الموقع تلقائياً عند النقر على الخريطة"
            />
            {formErrors.map_address && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.map_address[0]}</div>
            )}
          </Col>
          <Col md={4}>
            <Button 
              color="info" 
              className="w-100 fw-bold"
              size="lg"
              onClick={() => {
                // يمكن إضافة وظيفة لإعادة تعيين الموقع
                setFormValues(prev => ({...prev, map_address: ''}));
              }}
            >
              <i className="fas fa-map-marked-alt me-1"></i>
              إعادة تحديد الموقع
            </Button>
          </Col>
        </Row>

        {/* الخريطة */}
        <div className="position-relative">
          <div 
            id="map" 
            className="border border-2 border-info rounded-3 shadow-sm"
            style={{ height: "400px", width: "100%" }}
          ></div>
          
          {/* معلومات مساعدة */}
          <div className="mt-3 p-3 bg-light rounded border">
            <div className="d-flex align-items-center text-muted">
              <i className="fas fa-info-circle me-2 text-info"></i>
              <small className="fw-medium">
                انقر على الخريطة لتحديد موقع المؤسسة بدقة. يمكنك سحب العلامة لتعديل الموقع.
              </small>
            </div>
            {formErrors.new_person_type && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.new_person_type[0]}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
</TabPane>

              <TabPane tabId="4" data-tab-id="4">
  {/* ✅ وسائل التواصل والاتصال */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-phone me-2"></i>
        وسائل التواصل والاتصال
      </h5>
    </div>
    
    {/* أرقام الواتساب */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-success">
        <h6 className="text-success fw-bold mb-0">
          <i className="fab fa-whatsapp me-2"></i>
          أرقام الواتساب
        </h6>
      </div>
      <Row className="g-4">
        {/* واتساب 1 */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              واتساب 1 <span className="text-danger">*</span>
            </Label>
            <InputGroup className="input-group-lg">
              <Input
                type="text"
                name="whatsapp1_number"
                placeholder="رقم الجوال"
                value={formValues.whatsapp1_number || ''}
                onChange={handleChange}
                className={`border-2 ${formErrors.whatsapp1 ? 'is-invalid border-danger' : 'border-success'}`}
              />
              <select
                name="whatsapp1_code"
                value={formValues.whatsapp1_code || '+970'}
                onChange={handleChange}
                className={`form-select border-2 ${formErrors.whatsapp1 ? 'is-invalid border-danger' : 'border-success'}`}
                style={{ maxWidth: '100px' }}
              >
                <option value="+970">+970</option>
                <option value="+972">+972</option>
              </select>
            </InputGroup>
            {formErrors.whatsapp1 && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.whatsapp1[0]}</div>
            )}
          </div>
        </Col>

        {/* تلفون/فاكس */}
<Col md={6}>
  <div className="p-4 border rounded-3 shadow-sm bg-white">
    <Label className="form-label fw-bold mb-3 text-dark d-block">تلفون/فاكس</Label>
    <Input
      name="phone_fax"
      value={formValues.phone_fax}
      onChange={handleChange}
      placeholder="رقم التلفون أو الفاكس"
      className={`form-control-lg border-2 ${formErrors.phone_fax ? 'is-invalid border-danger' : 'border-success'}`}
    />
    {formErrors.phone_fax && (
      <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.phone_fax[0]}</div>
    )}
  </div>
</Col>
      </Row>
    </div>

    {/* أرقام الجوال */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-info">
        <h6 className="text-info fw-bold mb-0">
          <i className="fas fa-mobile-alt me-2"></i>
          أرقام الجوال
        </h6>
      </div>
      <Row className="g-4">
        {/* جوال 1 */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">جوال 1</Label>
            <Input
              name="mobile1"
              value={formValues.mobile1}
              onChange={handleChange}
              placeholder="أدخل رقم الجوال الأول"
              className={`form-control-lg border-2 ${formErrors.mobile1 ? 'is-invalid border-danger' : 'border-info'}`}
            />
            {formErrors.mobile1 && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.mobile1[0]}</div>
            )}
          </div>
        </Col>

       {/* أوريدو */}
<Col md={6}>
  <div className="p-4 border rounded-3 shadow-sm bg-white">
    <Label className="form-label fw-bold mb-3 text-dark d-block">رقم أوريدو</Label>
    <Input
      name="oreedo_number"
      value={formValues.oreedo_number}
      onChange={handleChange}
      placeholder="رقم أوريدو"
      className={`form-control-lg border-2 ${formErrors.oreedo_number ? 'is-invalid border-danger' : 'border-info'}`}
    />
    {formErrors.oreedo_number && (
      <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.oreedo_number[0]}</div>
    )}
  </div>
</Col>
      </Row>
    </div>

    {/* البريد الإلكتروني والموقع */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-warning">
        <h6 className="text-warning fw-bold mb-0">
          <i className="fas fa-globe me-2"></i>
          الاتصال الإلكتروني
        </h6>
      </div>
      <Row className="g-4">
        {/* البريد الإلكتروني */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-envelope me-2 text-warning"></i>
              البريد الإلكتروني
            </Label>
            <Input
              type="email"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              placeholder="example@domain.com"
              className={`form-control-lg border-2 ${formErrors.email ? 'is-invalid border-danger' : 'border-warning'}`}
            />
            {formErrors.email && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.email[0]}</div>
            )}
          </div>
        </Col>

        {/* الموقع الإلكتروني */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-link me-2 text-warning"></i>
              الموقع الإلكتروني
            </Label>
            <Input
              type="url"
              name="website"
              value={formValues.website}
              onChange={handleChange}
              placeholder="https://www.example.com"
              className={`form-control-lg border-2 ${formErrors.website ? 'is-invalid border-danger' : 'border-warning'}`}
            />
            {formErrors.website && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.website[0]}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>

    {/* حسابات التواصل الاجتماعي */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-secondary">
        <h6 className="text-secondary fw-bold mb-0">
          <i className="fas fa-share-alt me-2"></i>
          حسابات التواصل الاجتماعي
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* إضافة حساب جديد */}
        <div className="mb-4 p-3 border-2 border-dashed border-secondary rounded-3 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">إضافة رابط حساب التواصل</Label>
          <InputGroup className="input-group-lg">
            <Input
              placeholder="https://facebook.com/institution أو https://twitter.com/institution"
              value={newSocialAccount}
              onChange={(e) => setNewSocialAccount(e.target.value)}
              className="border-2 border-secondary"
            />
            <Button
              color="secondary"
              onClick={() =>
                handleAddToArray('social_accounts', setNewSocialAccount, newSocialAccount)
              }
              className="fw-bold"
            >
              <i className="fas fa-plus me-1"></i>
              إضافة
            </Button>
          </InputGroup>
        </div>

        {/* عرض الحسابات المضافة */}
        {formValues.social_accounts?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الحسابات المضافة:</Label>
            <div className="list-group">
              {formValues.social_accounts?.map((link, i) => (
                <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-link fa-lg me-3 text-secondary"></i>
                    <div>
                      <div className="fw-medium">{link}</div>
                      <small className="text-muted">رابط تواصل اجتماعي</small>
                    </div>
                  </div>
                  <Button 
                    color="outline-danger" 
                    size="sm"
                    onClick={() => handleRemoveFromArray('social_accounts', i)}
                    className="fw-medium"
                  >
                    <i className="fas fa-trash me-1"></i>
                    حذف
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-share-alt fa-2x mb-3 opacity-50"></i>
            <p>لم يتم إضافة أي حسابات تواصل اجتماعي بعد</p>
          </div>
        )}
      </div>
    </div>
  </div>
</TabPane>

              <TabPane tabId="5" data-tab-id="5">
  {/* ✅ المرفقات والوسائط */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-info fw-bold mb-0">
        <i className="fas fa-file-upload me-2"></i>
        المرفقات والوسائط
      </h5>
    </div>

    {/* ✅ روابط يوتيوب */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-danger">
        <h6 className="text-danger fw-bold mb-0">
          <i className="fab fa-youtube me-2"></i>
          روابط يوتيوب
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* إضافة رابط يوتيوب */}
        <div className="p-4 border-2 border-dashed border-danger rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">إضافة رابط يوتيوب</Label>
          <InputGroup className="input-group-lg">
            <Input
              placeholder="https://youtube.com/watch?v=..."
              value={newYoutubeLink}
              onChange={(e) => setNewYoutubeLink(e.target.value)}
              className={`border-2 ${formErrors.youtube_links ? 'is-invalid border-danger' : 'border-danger'}`}
            />
            <Button
              color="danger"
              onClick={() => handleAddToArray('youtube_links', setNewYoutubeLink, newYoutubeLink)}
              className="fw-bold"
            >
              <i className="fab fa-youtube me-1"></i>
              إضافة
            </Button>
          </InputGroup>
          {formErrors.youtube_links && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.youtube_links[0]}</div>
          )}
        </div>

        {/* عرض روابط اليوتيوب */}
        {formValues.youtube_links?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الفيديوهات المضافة:</Label>
            <div className="list-group">
              {formValues.youtube_links.map((link, i) => (
                <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <i className="fab fa-youtube fa-lg me-3 text-danger"></i>
                    <div>
                      <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{link}</div>
                      <small className="text-muted">فيديو يوتيوب</small>
                    </div>
                  </div>
                  <Button 
                    color="outline-danger" 
                    size="sm"
                    onClick={() => handleRemoveFromArray('youtube_links', i)}
                    className="fw-medium"
                  >
                    <i className="fas fa-trash me-1"></i>
                    حذف
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fab fa-youtube fa-2x mb-3 opacity-50"></i>
            <p>لم يتم إضافة أي فيديوهات يوتيوب بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* 🆕 ملفات الفيديو */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-purple" style={{borderColor: '#6f42c1'}}>
        <h6 className="fw-bold mb-0" style={{color: '#6f42c1'}}>
          <i className="fas fa-video me-2"></i>
          ملفات الفيديو
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع الفيديو */}
        <div className="p-4 border-2 border-dashed rounded-3 mb-4 bg-light" style={{borderColor: '#6f42c1'}}>
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع ملفات الفيديو</Label>
          <Input
            type="file"
            multiple
            accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/wmv,video/mkv,video/flv,video/3gp,video/m4v,.mp4,.webm,.ogg,.avi,.mov,.wmv,.mkv,.flv,.3gp,.m4v"
            onChange={handleVideoUpload}
            className={`form-control-lg border-2 ${formErrors.video_files ? 'is-invalid border-danger' : ''}`}
            style={{borderColor: '#6f42c1'}}
            innerRef={videoInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
            <p className="mb-0">اختر ملفات فيديو متعددة</p>
            <small>MP4, WebM, OGG, AVI, MOV, WMV, MKV, FLV, 3GP, M4V - حتى 1GB لكل ملف</small>
          </div>
          {formErrors.video_files && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.video_files[0]}</div>
          )}
        </div>

        {/* عرض ملفات الفيديو */}
        {videoFiles.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">ملفات الفيديو ({videoFiles.length}):</Label>
            <div className="list-group">
              {videoFiles.map((file, index) => {
                const isUploaded = typeof file === 'string';
                const tempId = !isUploaded ? file.tempId : null;
                const uploadState = tempId ? videoUploading[tempId] : null;
                const fileName = isUploaded ? file : file.name;
                const fileSize = isUploaded ? '' : (file.size / (1024 * 1024)).toFixed(1) + ' MB';
                const isUploading = uploadState?.status === 'uploading';
                const hasError = uploadState?.status === 'error';
                
                return (
                  <div key={tempId || index} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center flex-grow-1">
                        {isUploading ? (
                          <div className="spinner-border spinner-border-sm me-3" style={{color: '#6f42c1'}} role="status">
                            <span className="visually-hidden">جاري الرفع...</span>
                          </div>
                        ) : isUploaded ? (
                          <i className="fas fa-check-circle fa-lg me-3 text-success"></i>
                        ) : hasError ? (
                          <i className="fas fa-exclamation-circle fa-lg me-3 text-danger"></i>
                        ) : (
                          <i className="fas fa-video fa-lg me-3" style={{color: '#6f42c1'}}></i>
                        )}
                        <div className="flex-grow-1">
                          <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{fileName}</div>
                          <small className="text-muted">
                            {isUploading ? (
                              <span className="text-primary">جاري الرفع... {uploadState?.progress || 0}%</span>
                            ) : isUploaded ? (
                              <span className="text-success">✓ تم الرفع بنجاح</span>
                            ) : hasError ? (
                              <span className="text-danger">{uploadState?.message || 'فشل الرفع'}</span>
                            ) : (
                              `فيديو • ${fileSize}`
                            )}
                          </small>
                        </div>
                      </div>
                      {isUploaded && (
                        <Button
                          color="outline-danger"
                          size="sm"
                          onClick={() => {
                            const updated = [...videoFiles];
                            updated.splice(index, 1);
                            setVideoFiles(updated);
                          }}
                          className="fw-medium"
                        >
                          <i className="fas fa-trash me-1"></i>
                          حذف
                        </Button>
                      )}
                    </div>
                    {/* شريط التقدم */}
                    {isUploading && (
                      <div className="progress mt-2" style={{height: '6px'}}>
                        <div 
                          className="progress-bar" 
                          role="progressbar" 
                          style={{width: `${uploadState?.progress || 0}%`, backgroundColor: '#6f42c1'}}
                          aria-valuenow={uploadState?.progress || 0} 
                          aria-valuemin="0" 
                          aria-valuemax="100"
                        ></div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-video fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي ملفات فيديو بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ الصور */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-warning">
        <h6 className="text-warning fw-bold mb-0">
          <i className="fas fa-images me-2"></i>
          الصور
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع الصور */}
        <div className="p-4 border-2 border-dashed border-warning rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع الصور</Label>
          <Input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className={`form-control-lg border-2 ${formErrors.images ? 'is-invalid border-danger' : 'border-warning'}`}
            innerRef={imageInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
            <p className="mb-0">اختر صور متعددة</p>
            <small>PNG, JPG, JPEG حتى 5MB لكل صورة</small>
          </div>
          {formErrors.images && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.images[0]}</div>
          )}
        </div>

        {/* عرض الصور */}
        {images.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الصور المرفوعة ({images.length}):</Label>
            <Row className="g-3">
              {images.map((file, index) => {
               const isExisting = typeof file === 'string';
               const imageUrl = isExisting
                 ? `${FILE_BASE_URL}/uploads/images/${file}`
                 : URL.createObjectURL(file);

                return (
                  <Col key={index} md={2} sm={3} xs={4}>
                    <div className="position-relative">
                      <img
                        src={imageUrl}
                        alt={`preview-${index}`}
                        className="img-fluid rounded shadow-sm border border-2 border-warning"
                        style={{ height: "120px", width: "100%", objectFit: "cover" }}
                      />
                      <Button
                        color="danger"
                        onClick={() => {
                          setImages(prev => prev.filter((_, i) => i !== index));
                          if (!isExisting && imageInputRef.current) imageInputRef.current.value = null;
                        }}
                        className="position-absolute top-0 end-0 rounded-circle"
                        style={{
                          width: "30px",
                          height: "30px",
                          padding: "0",
                          fontSize: "12px",
                          transform: "translate(50%, -50%)"
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-images fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي صور بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ مرفقات أخرى */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-secondary">
        <h6 className="text-secondary fw-bold mb-0">
          <i className="fas fa-paperclip me-2"></i>
          مرفقات أخرى
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع المرفقات */}
        <div className="p-4 border-2 border-dashed border-secondary rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع الملفات</Label>
          <Input
            type="file"
            multiple
            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setFormValues(prev => ({
                ...prev,
                attachments: [...prev.attachments, ...files]
              }));
              if (attachmentInputRef.current) attachmentInputRef.current.value = null;
            }}
            className={`form-control-lg border-2 ${formErrors.attachments ? 'is-invalid border-danger' : 'border-secondary'}`}
            innerRef={attachmentInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-file-upload fa-2x mb-2"></i>
            <p className="mb-0">اختر ملفات متعددة</p>
            <small>PDF, Word, Excel, TXT حتى 10MB لكل ملف</small>
          </div>
          {formErrors.attachments && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.attachments[0]}</div>
          )}
        </div>

        {/* عرض المرفقات */}
        {formValues.attachments?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الملفات المرفقة ({formValues.attachments.length}):</Label>
            <div className="list-group">
              {formValues.attachments.map((file, index) => {
                const fileName = typeof file === 'string' ? file : file.name;
                const meta = renderFileMeta(fileName);
                return (
                  <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <i className={`${meta.icon} fa-lg me-3 ${meta.color}`}></i>
                      <div>
                        <div className="fw-medium text-truncate" style={{ maxWidth: 400 }}>{fileName}</div>
                        <small className="text-muted">{meta.label}</small>
                      </div>
                    </div>
                    <Button
                      color="outline-danger"
                      size="sm"
                      onClick={() =>
                        setFormValues(prev => ({
                          ...prev,
                          attachments: prev.attachments.filter((_, i) => i !== index)
                        }))
                      }
                      className="fw-medium"
                    >
                      <i className="fas fa-trash me-1"></i> حذف
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-paperclip fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي ملفات بعد</p>
          </div>
        )}
      </div>
    </div>
  </div>
</TabPane>
              
            </TabContent>

            {/* Errors modal (تظهر عند وجود أخطاء محلية) */}
            <div>
              {/* Modal simple implementation */}
              {showErrorsModal && (
                <div className="modal-backdrop show" style={{ zIndex: 1050 }}></div>
              )}
              <div className={`modal fade ${showErrorsModal ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showErrorsModal} style={{ zIndex: 1060 }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">الحقول المطلوبة</h5>
                      <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowErrorsModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      <p>يرجى إكمال الحقول التالية قبل الحفظ. اضغط للذهاب إلى الحقل:</p>
                      <ul className="list-group">
                        {errorsList.map((it, idx) => (
                          <li key={idx} className="list-group-item list-group-item-action" style={{ cursor: 'pointer' }} onClick={() => jumpToField(it)}>
                            <strong>{it.label}</strong> — {it.message}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowErrorsModal(false)}>إغلاق</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-end mt-4">
              <Button color="primary" type="submit" disabled={isSubmitting || !areAllVideosUploaded()}>
                {!areAllVideosUploaded() ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    جاري رفع الفيديوهات...
                  </>
                ) : isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    جاري الحفظ...
                  </>
                ) : (
                  mode === 'edit' ? 'تحديث المؤسسة' : 'إضافة المؤسسة'
                )}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>

      {/* 🆕 بوب أب تأكيد الحفظ عند وجود أسماء مكررة */}
      <DuplicateSaveConfirm
        isOpen={showDuplicateConfirm}
        matches={duplicateWarning}
        onConfirm={() => { setShowDuplicateConfirm(false); doActualSubmit(); }}
        onCancel={() => { setShowDuplicateConfirm(false); setIsSubmitting(false); }}
      />
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CreateInstitution);